<template>
  <div>
    <div>
      <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/worldmap-2.jpg');
              background-position: top !important;
            "
          ></div>

          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t("news_Letter_Management") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb v-if="!editMode" />
    <Breadcrumb
      v-else
      :trainingNameEdit="newsLetter.subjectLine[$locale.toUpperCase()]"
    />
    <div class="mx-0 row align-items-start newsletter_management">
      <div class="col-xl-12 px-8">
        <div class="d-flex justify-between create_nl_title mb-5 pt-4">
          <h3>{{ $t("compose_newsletter") }}</h3>

          <a @click="cancelNewsLetter()" class="back_btn">
            <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}
          </a>
        </div>

        <div class="row disablerow justify-content-between align-items-start">
          <!-- Tabs -->
          <v-tabs
            v-model="languageTab"
            align-with-title
            touchless
            scrollable
            show-arrows
            class="LanguageselectTabgroup pt-md-4 pt-lg-0 pl-md-8 pl-4"
          >
            <v-tabs-slider color="indigo"></v-tabs-slider>

            <v-tab
              v-for="(language, i) in languageTabsNew"
              :key="language + i"
              class="LanguageselectTab"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    style="display: flex; align-items: center"
                  >
                    <img
                      style="width: 26px; height: 17px; vertical-align: unset"
                      :src="'/files/flags/' + language.flag"
                    />
                    &nbsp;&nbsp;
                    <span class="langauge-text-slider">
                      {{
                        language.shortForm === "KK"
                          ? "KZ"
                          : language.shortForm === "ZH" ||
                            language.shortForm === "CN"
                          ? "CN"
                          : $t(language.shortForm)
                      }}
                    </span>
                  </div>
                </template>
                <span>{{ $t(language.language) }}</span>
              </v-tooltip>
            </v-tab>
          </v-tabs>
          <div class="col-xl-9 newsletter_bg subject_line">
            <div class="">
              <v-tabs-items v-model="languageTab" touchless>
                <v-tab-item
                  v-for="(language, i) in languageTabsNew"
                  :key="language + i"
                >
                  <div class="row disablerow justify-center">
                    <!-- Put Content here -->

                    <div class="">
                      <!-- <div
                    class="pt-4 mx-0 row main_tabuler justify-content-sm-between justify-content-center"
                  >
                    <h3>{{ $t("create_Newsletter") }}</h3>

                    <a :href="`/manage-newsletter`" class="back_btn">
                      <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}
                    </a>
                  </div> -->

                      <!-- <p>{{ $t("enter_Mail_Details") }}</p> -->
                      <div>
                        <div class="">
                          <div class="row disablerow">
                            <div class="">
                              <div class="center_wrapper">
                                <p class="mb-2 mt-2 justify-between">
                                  <span>{{ $t("enter_your_Subject") }}</span>
                                  <span
                                    >{{
                                      newsLetter.subjectLine[language.shortForm]
                                        ?.length || 0
                                    }}/150</span
                                  >
                                </p>

                                <v-text-field
                                  hide-details="auto"
                                  class="datainput justify-content-end align-self-center pb-1 subject_heading"
                                  dense
                                  outlined
                                  :label="$t('subject_line')"
                                  v-model="
                                    newsLetter.subjectLine[language.shortForm]
                                  "
                                  maxlength="150"
                                ></v-text-field>

                                <p class="mt-2 justify-between">
                                  <span>{{ $t("newsletter_header") }}</span>
                                  <span>{{ $t("recommended_width") }}</span>
                                </p>

                                <div class="mt-0 row disablerow upload_label">
                                  <div class="col-md-12 p-0 pt-2">
                                    <Upload v-model="newsLetter.image" />
                                    <div v-if="newsLetter.image" class="mt-3">
                                      <img
                                        :src="`/files/images/${newsLetter.image}`"
                                        alt="Uploaded Image"
                                        class="upload-image-preview"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <p class="mt-7">{{ $t("email_body") }}</p>
                                <div
                                  class="html-editor cust-html-editor custom_body mt-3"
                                >
                                  <vue-editor
                                    v-model="
                                      newsLetter.body[language.shortForm]
                                    "
                                    :key="$i18n.locale"
                                    :editor-options="editorOptions"
                                    class="custom-editor"
                                    style="height: 600px"
                                    :placeholder="contentPlaceholder"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>

          <div
            class="col-xl-3 padding-30 pr-0 pt-0 d-flex flex-column nl_right_colum"
          >
            <div class="newsletter_bg padding-30">
              <p class="nl_head_title">{{ $t("send_to") }}</p>

              <v-select
                hide-details="auto"
                dense
                outlined
                class="datainput mt-2"
                :items="audiences"
                :label="$t('select_subscribers_group') + '*'"
                :item-text="
                  (item) => `${item.designation} (${item.subscriptionCount})`
                "
                item-value="id"
                multiple
                v-model="newsLetter.audienceId"
              ></v-select>
            </div>
            <div class="newsletter_bg padding-30">
              <p class="mb-4 nl_head_title">
                {{ $t("form_title") }}
              </p>
              <!--<p class="mb-4">{{$t("from_Name_And_Email")}}</p>-->
              <p>
                <strong>{{ $t("rail_Services") }}</strong>
              </p>
              <p>{{ $t("mail") }}</p>
            </div>
            <div class="col-md-12 p-0 d-flex g-space-15 viewer_btn">
              <v-btn
                @click="saveNewsLetter()"
                outlined
                depressed
                tile
                class="savebutton"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                @click="cancelNewsLetter()"
                outlined
                depressed
                tile
                class="cancelBtn"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                @click="previewNewsLetter()"
                :disabled="!isSaved"
                outlined
                depressed
                tile
                class="savebutton"
              >
                <img src="/static/img/newsletter_preview.svg" />
                {{ $t("preview_continue") }}</v-btn
              >
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "./custom/Card.vue";
import Breadcrumb from "./Breadcrumbs.vue";
import Quill from "quill";
import ImageResize from "quill-image-resize-module--fix-imports-error";
Quill.register("modules/imageResize", ImageResize);
export default {
  components: {
    Card,
    Breadcrumb,
  },
  data() {
    return {
      editMode: false,
      audiences: null,
      languageTab: null,
      newsLetter: {
        id: null,
        subjectLine: {},
        image: null,
        body: {},
        audienceId: [],
        newsletterStatus: "0",
      },
      isSaved: false,
      originalNewsLetter: {},
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }],
        ["link", "image"],
        ["clean"],
      ],
      editorOptions: {
        modules: {
          imageResize: {
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
        },
      },
      htmlBackup: {},
      showHtml: {},
      //  contentPlaceholder: "",
    };
  },
  watch: {
    "$i18n.locale"() {
      this.$nextTick(() => {
        this.updateEditorPlaceholder();
      });
    },
  },
  computed: {
    contentPlaceholder() {
      const currentLocale = this.$i18n.locale;
      return this.$t("Compose_content");
    },
    languageTabsNew() {
      return this.$root.languageTabsNew;
    },
    isModified() {
      return (
        JSON.stringify(this.newsLetter) !==
        JSON.stringify(this.originalNewsLetter)
      );
    },
  },
  async mounted() {
    var _this = this;
    this.updateEditorPlaceholder();
     if (this.$route.query.newsLetterId) {
      this.editMode = true;
     }
    if (
      this.isLoad != true &&
      !window.location.href.includes("?") &&
      !window.location.href.includes("?lang=")
    ) {
      this.isLoad = true;
      window.location.href =
        window.location.href + "?lang=" + this.$locale.toUpperCase();
    }else if (
      this.isLoad != true &&
      this.editMode &&
      !window.location.href.includes("&lang=")
    ) {
      window.location.href =
        window.location.href + "&lang=" + this.$locale.toUpperCase();
    }

    if (this.$route.query.newsLetterId) {
      await this.$axios
        .get(
          "/api/newsletter/newsletter/" +
            parseInt(this.$route.query.newsLetterId)
        )
        .then(function (response) {
          _this.newsLetter = response.data;
          _this.newsLetter.id = response.data.id;
 _this.newsLetter = {
      ...response.data,
      subjectLine: _this.normalizeMapKeys(response.data.subjectMap),
      body: _this.normalizeMapKeys(response.data.bodyMap)
    };

          _this.originalNewsLetter = JSON.parse(
            JSON.stringify(_this.newsLetter)
          );
        });
    }
    this.fetchAllAudience();
  },
    updated() {
    let _this = this;
    let language = _this.$locale;
    },
  methods: {
    updateEditorPlaceholder() {
      const editorInstance = this.$refs.editor?.quill;
      if (editorInstance?.root) {
        editorInstance.root.dataset.placeholder = this.$t("Compose_content");
        editorInstance.root.dispatchEvent(new Event("blur"));
      }
    },
  normalizeMapKeys(map) {
  const normalized = {};
  Object.keys(map).forEach(key => {
    // Convert all keys to uppercase (or lowercase if you prefer)
    const upperKey = key.toUpperCase();
    normalized[upperKey] = map[key];
  });
  return normalized;
},
    fetchAllAudience() {
      var _this = this;
      this.$axios
        .get("/api/newsletter/get-newsletter-audience")
        .then(function (response) {
          _this.audiences = response.data;
        })
        .catch(this.onError);
    },
    onFinally() {
      showLoadingCircle(false);
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    previewNewsLetter() {
      this.$router.push(
        "/preview-news-letter?newsLetterId=" + this.newsLetter.id
      );
    },

    cancelNewsLetter() {
      this.$router.push({
        path: "/manage-newsletter",
        query: { selectedTab: 1 },
      });
    },

    saveNewsLetter() {
      var _this = this;

      _this.newsLetter.isDuplicated = "0";
      const languages = [
        "EN",
        "DE",
        "FR",
        "PL",
        "ES",
        "HU",
        "RU",
        "KK",
        "IT",
        "ZH",
      ];

      const allEmptyOrSpacesSubjectLine = languages.every((lang) =>
        this.$isStringEmptyOrNull(_this.newsLetter.subjectLine[lang])
      );

      if (allEmptyOrSpacesSubjectLine) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("enter_your_Subject") })
        );
        return;
      }

      const allEmptyOrSpacesBody = languages.every((lang) =>
        this.$isStringEmptyOrNull(_this.newsLetter.body[lang])
      );

      if (allEmptyOrSpacesBody) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("email_body") })
        );
        return;
      }
      if (_this.newsLetter.audienceId.length === 0) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("select_subscribers_group") })
        );
        return;
      }
      _this.$convertHtmlDescriptionText(_this.newsLetter.subjectLine);
      _this.$convertHtmlDescriptionText(_this.newsLetter.body);
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      if (_this.newsLetter.id === null) {
        this.$axios
          .post("/api/newsletter/newsletter/", _this.newsLetter)
          .then(function (response) {
            _this.newsLetter = response.data;
         _this.newsLetter.id = response.data.id;
 _this.newsLetter = {
      ...response.data,
      subjectLine: _this.normalizeMapKeys(response.data.subjectMap),
      body: _this.normalizeMapKeys(response.data.bodyMap)
    };

            _this.isSaved = true;
          })
          .catch(this.onError)
          .finally(this.onFinally);
      } else {
        this.$axios
          .put("/api/newsletter/newsletter/", _this.newsLetter)
          .then(function (response) {
            _this.newsLetter = response.data;
          _this.newsLetter.id = response.data.id;
 _this.newsLetter = {
      ...response.data,
      subjectLine: _this.normalizeMapKeys(response.data.subjectMap),
      body: _this.normalizeMapKeys(response.data.bodyMap)
    };
            _this.isSaved = true;
          })
          .catch(this.onError)
          .finally(this.onFinally);
      }
    },
  },
};
</script>
